import React from 'react'
import PageHeading from '../Global/PageHeading'
import CropModal from './CropModal'
import PasswordModal from './PasswordModal'
/* REDUX */
import { connect } from 'react-redux'
import { loadUser } from '../../actions/auth'
import { updateUser } from '../../actions/user'
/* FIREBASE */
import b64toBlob from 'b64-to-blob'
import * as firebase from 'firebase'

class UpdateBtn extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			updating: false,
			updated: false
		}
		this.handleClick = this.handleClick.bind(this)
		this.toggleUpdate = this.toggleUpdate.bind(this)
	}
	
	handleClick() {
		this.setState({
			updating: true,
			updated: false
		})
		this.props.handleSubmit(this.toggleUpdate)
	}
	
	toggleUpdate() {
		this.setState({
			updating: false,
			updated: true
		})
	}
	
	render() {
		return (
			<div className="basebar d-flex align-items-center">
				{ this.state.updating ? (<button type="button" className="btn btn-submit" onClick={ this.handleClick } disabled>Update</button>):(<button type="button" className="btn btn-submit" onClick={ this.handleClick } >Update</button>)}
				{ this.state.updating ? (<span className="updating-txt">Updating <i className="fa fa-spinner fa-spin"></i></span>):(null) }
				{ this.state.updated ? (<div className="success-wrap"><span className="updated-txt">Updated</span><span className="success-icon ml-1"><svg viewBox="0 0 512 512"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path></svg></span></div>):(null) }
			</div>
		)
	}
}

const loadData = ({ loadUser }) => {
	loadUser()
}

class Content extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			name: '',
			headline: '',
			email: '',
			Facebook: '',
			Twitter: '',
			Youtube: '',
			Website: '',
			imgURI: "",
			profile_picture: 'https://firebasestorage.googleapis.com/v0/b/theflightpost.appspot.com/o/users%2F5976702cffb33336cf827d95.jpg?alt=media&token=ca35d7cc-a99f-4e97-bffd-87ed7a68f70c',
			showUpload: true,
			disableSubmit: false,
			submitting: false,
			modal: false,
			imageUploaded: false
		}
		this.handleInputChange = this.handleInputChange.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
		this.handleFirebase = this.handleFirebase.bind(this)
		this.onModal = this.onModal.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onOverlay = this.onOverlay.bind(this);
		this.setDefaultImage = this.setDefaultImage.bind(this);
	}
	
	componentWillMount() {
		loadData(this.props)
	}
	
	componentWillReceiveProps(nextProps) {
		const { user } = nextProps
		const { name, headline, email, profile_picture, social } = user
		const Facebook = social ? social.Facebook : ''
		const Twitter = social ? social.Twitter : ''
		const Youtube = social ? social.Youtube : ''
		const Website = social ? social.Website : ''
		this.setState({
			name: name,
			headline: headline,
			email: email,
			profile_picture: profile_picture,
			Facebook: Facebook,
			Twitter: Twitter,
			Youtube: Youtube,
			Website: Website
		})
	}
	
	handleInputChange(event) {
		const target = event.target
		const value = target.value
		const name = target.name
		
		this.setState({
		  [name]: value
		});
	}
	
	handleSubmit(cb) {
		if (this.state.imageUploaded) {
			this.callFirebaseAPI(this.props.user._id, cb)
		} else {
			this.props.updateUser(this.state, cb)
		}
	}
	
	/** PASSWORD MODAL **/
	
	onModal(abortUpload) {
		document.body.classList.add('modal-open');
		this.setState({
			modal: true
		});
	}

	onClose() {
		document.body.classList.remove('modal-open');
		this.setState({
			modal: false
		});
	}
	
	onOverlay(e) {
		if (e.target.dataset.modal) {
			this.onClose();
		}
	}
	
	/** IMAGE HANDLER **/
	
	handleFirebase(downloadURL, cb) {
		const formProps = this.state
		const newProps = {
			...formProps,
			profile_picture: downloadURL
		}
		this.props.updateUser(newProps, cb)
	}
	
	callFirebaseAPI = (user_id, cb) => {
		const imageURI = document.getElementById("uploadedImage").src
		var data = b64toBlob(imageURI.split(',')[1], 'image/jpeg')
		this.uploadFirebase(user_id, data, this.handleFirebase, cb)
	}
	
	uploadFirebase = (user_id, data, callback, cb) => {
		let file = data;
	    let storageRef = firebase.storage().ref()
	    let uploadTask = storageRef.child('users/' + user_id + '.jpg').put(file);
	    uploadTask.on('state_changed', function(snapshot){
			var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
			console.log('Upload is ' + progress + '% done');
		}, function(error) {
			console.log(error);
		}, function() {
			var downloadURL = uploadTask.snapshot.downloadURL;
			callback(downloadURL, cb)
		});
	}
	
	setDisable() {
		this.setState({
			disableSubmit: true
		})
	}
	
	removeDisable() {
		this.setState({
			disableSubmit: false
		})
	}
	
	getBase64 = (file) => {
		let reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = function () {
			this.setState({
				imgURI: reader.result,
				showUpload: false
			})
		}.bind(this)
		reader.onerror = function (error) {
			console.log('Error: ', error)
		}
	}

	fileUpload = () => {
		let fileModule = document.getElementById('fileInput')
		let toUpload = fileModule.files[0]
		if (toUpload) {
			this.getBase64(toUpload)
		}
	}
	
	refreshUpload = () => {
		this.setState({
			imgURI: ""
		})
	}
	
	setImageUploaded = () => {
		this.setState({
			imageUploaded: true
		})
	}
	
	setDefaultImage = () => {
		this.setState({
			imgURI: "https://firebasestorage.googleapis.com/v0/b/theflightpost.appspot.com/o/users%2F5976702cffb33336cf827d95.jpg?alt=media&token=ca35d7cc-a99f-4e97-bffd-87ed7a68f70c",
			profile_picture: "https://firebasestorage.googleapis.com/v0/b/theflightpost.appspot.com/o/users%2F5976702cffb33336cf827d95.jpg?alt=media&token=ca35d7cc-a99f-4e97-bffd-87ed7a68f70c",
			imageUploaded: false
		})
		document.getElementById("uploadedImage").src = 'https://firebasestorage.googleapis.com/v0/b/theflightpost.appspot.com/o/users%2F5976702cffb33336cf827d95.jpg?alt=media&token=ca35d7cc-a99f-4e97-bffd-87ed7a68f70c'
	}
	
	render() {
		
		const { user } = this.props
		const { name, headline, email, social, profile_picture } = user
		
		const def_profile_picture = profile_picture ? profile_picture : "https://firebasestorage.googleapis.com/v0/b/theflightpost.appspot.com/o/users%2F5976702cffb33336cf827d95.jpg?alt=media&token=ca35d7cc-a99f-4e97-bffd-87ed7a68f70c"
		
		return (
			<section className="content">
				<div className="container">
					<PageHeading heading={ "Settings" } />
					<form>
						<div className="settings shared">
							<h4 className="title">My Details</h4>
							<div className="block">
								<div className="row d-flex align-items-center">
									<div className="col-3 col-sm-2 col-lg-1">
										<div className="left">
											<span>Name</span>
										</div>
									</div>
									<div className="col-9 col-sm-10 col-lg-11">
										<div className="right">
											<input type="text" name="name" value={ this.state.name } onChange={ this.handleInputChange } />
										</div>
									</div>
								</div>
							</div>
							<div className="block">
								<div className="row d-flex align-items-center">
									<div className="col-3 col-sm-2 col-lg-1">
										<div className="left">
											<span>Headline</span>
										</div>
									</div>
									<div className="col-9 col-sm-10 col-lg-11">
										<div className="right">
											<input type="text" name="headline" value={ this.state.headline } onChange={ this.handleInputChange } />
										</div>
									</div>
								</div>
							</div>
							<div className="block">
								<div className="row d-flex align-items-center">
									<div className="col-3 col-sm-2 col-lg-1">
										<div className="left">
											<span>Email</span>
										</div>
									</div>
									<div className="col-9 col-sm-10 col-lg-11">
										<div className="right">
											<input type="text" name="email" value={ this.state.email } onChange={ this.handleInputChange } />
										</div>
									</div>
								</div>
							</div>
							<div className="block">
								<div className="row d-flex align-items-center">
									<div className="col-3 col-sm-2 col-lg-1">
										<div className="left">
											<span>Password</span>
										</div>
									</div>
									<div className="col-9 col-sm-10 col-lg-11">
										<div className="right">
											<button type="button" className="btn btn-reset" onClick={ this.onModal }>Change Password</button>
										</div>
									</div>
								</div>
							</div>
							<div className="block">
								<div className="row d-flex align-items-top">
									<div className="col-3 col-sm-2 col-lg-1">
										<div className="left">
											<span>Picture</span>
										</div>
									</div>
									<div className="col-9 col-sm-10 col-lg-11">
										<div className="right">
											<div className="file-upload-wrapper sm">
												<div className="file-upload-image active" id="uploadedImageWrapper">
													<img id="uploadedImage" src={ def_profile_picture } />
												</div>
												<CropModal imgURI={ this.state.imgURI } setDisable={ this.setDisable.bind(this) } removeDisable={ this.removeDisable.bind(this) } setImageUploaded={ this.setImageUploaded.bind(this) } />
												<div>
													{this.state.submitting ?(
														<div className="file-upload btn btn-upload" disabled>
															<span><span className="icon icon-image"></span> Select a New Image</span>
															<input id="fileInput" className="form-control-file upload" type="file" accept="image/x-png,image/jpeg" onChange={ this.fileUpload.bind(this) }/>
														</div>
													):(
														<div className="file-upload btn btn-upload">
															<span><span className="icon icon-image"></span> Select a New Image</span>
															<input id="fileInput" className="form-control-file upload" type="file" accept="image/x-png,image/jpeg" onChange={ this.fileUpload.bind(this) }/>
														</div>
													)}
													<div className="btn-default" id="removeProfilePicture">
														<span onClick={ this.setDefaultImage }>Remove Profile Picture</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="block">
								<div className="row d-flex align-items-center">
									<div className="col-3 col-sm-2 col-lg-1">
										<div className="left">
											<span>Facebook</span>
										</div>
									</div>
									<div className="col-9 col-sm-10 col-lg-11">
										<div className="right">
											<input type="text" name="Facebook" placeholder="https://" value={ this.state.Facebook } onChange={ this.handleInputChange } />
										</div>
									</div>
								</div>
							</div>
							<div className="block">
								<div className="row d-flex align-items-center">
									<div className="col-3 col-sm-2 col-lg-1">
										<div className="left">
											<span>Twitter</span>
										</div>
									</div>
									<div className="col-9 col-sm-10 col-lg-11">
										<div className="right">
											<input type="text" name="Twitter" placeholder="https://" value={ this.state.Twitter } onChange={ this.handleInputChange } />
										</div>
									</div>
								</div>
							</div>
							<div className="block">
								<div className="row d-flex align-items-center">
									<div className="col-3 col-sm-2 col-lg-1">
										<div className="left">
											<span>Youtube</span>
										</div>
									</div>
									<div className="col-9 col-sm-10 col-lg-11">
										<div className="right">
											<input type="text" name="Youtube" placeholder="https://" value={ this.state.Youtube } onChange={ this.handleInputChange } />
										</div>
									</div>
								</div>
							</div>
							<div className="block">
								<div className="row d-flex align-items-center">
									<div className="col-3 col-sm-2 col-lg-1">
										<div className="left">
											<span>Website</span>
										</div>
									</div>
									<div className="col-9 col-sm-10 col-lg-11">
										<div className="right">
											<input type="text" name="Website" placeholder="https://" value={ this.state.Website } onChange={ this.handleInputChange } />
										</div>
									</div>
								</div>
							</div>						
						</div>
						<UpdateBtn handleSubmit={ this.handleSubmit } />
						<PasswordModal onOverlay={ this.onOverlay } onClose={ this.onClose } isOpen={ this.state.modal } transitionName="opacity" email={ email } />
					</form>
				</div>
			</section>
		)
	}
}

const mapStateToProps = (state) => {
	const { user } = state
	return {
		user: user.data
	}
}

export default connect(mapStateToProps, { loadUser, updateUser })(Content)


// WEBPACK FOOTER //
// ./src/components/Settings/Content.js